import React, { FC } from 'react';
import classes from './Page404.module.scss';

const Page404: FC = () => {
  return <div className={classes.container}>Извините, такой страницы не существует</div>;
};

export default Page404;
